import x from "../../../assets/images/X.png";
import back from "../../../assets/images/back.png";

import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import Search1 from "../../../assets/images/Search1.png";
import Previous from "../../../assets/images/Previous.png";
import SubCategory from "../../../Json/SubCategory.json";
import brands from "../../../Json/Brand.json";

import { useLocation, useNavigate } from "react-router-dom";
import { SetSearch } from "../../../features/TopSearches/TopSearchesSlice";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import {
  SetSelectdPage,
  SetSizeFilter,
  SetTopSizeFilter,
  SortProducts,
} from "../../../features/Products/ProductSlice";
import NotificationModal from "../NotificationModal";

function SeacrhMenuShoes({ show, setShow, id, setShowbefore, setShowfirst }) {
  const { i18n, t } = useTranslation();
  const { subtype } = useSelector((store) => store.topsearches);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sq, setsq] = useState("");

  let parametres = new URLSearchParams(useLocation().search);
  const ShoesDesigners = [
    {
      name: "Christian Louboutin",
    },
    {
      name: "Hermès",
    },
    {
      name: "Saint Laurent",
    },
    {
      name: "Fendi",
    },
    {
      name: "Chanel",
    },
    {
      name: "Gucci",
    },
    {
      name: "Louis Vuitton",
    },
    {
      name: "Dior",
    },
    {
      name: "Miu Miu",
    },
    {
      name: "Prada",
    },

    {
      name: "Celine",
    },
    {
      name: "Bottega Veneta",
    },
    {
      name: "Amina Muaddi",
    },
    {
      name: "Nike",
    },
    {
      name: "Jimmy Choo",
    },
  ];
  return (
    <>
      <Modal show={show} fullscreen className="modal fade mx-0 px-0">
        <Modal.Body className="p-0 m-0 ">
          <div className="modal-header justify-content-between align-items-center d-flex pb-0 px-4">
            <div style={{ cursor: "pointer" }}>
              <button
                type="button"
                className="close close-txt close-modal align-items-center px-0"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setShow(false)}
              >
                <img
                  alt="main"
                  src={back}
                  onClick={() => setShow(false)}
                  className={` ${
                    i18n.language == "en" ? "Previous" : "PreviousAr"
                  }`}
                />
              </button>
            </div>
            <button
              type="button"
              className="close close-txt close-modal align-items-center px-0"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => setShow(false)}
            >
              <img
                alt="main"
                src={x}
                onClick={() => setShow(false)}
                className="x-close  mb-1"
              />
            </button>
          </div>

          <div className="modal-body px-4">
            {subtype == "Designers" && (
              <>
                <div
                  className="w-100 pt-2 pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenutitle"
                    style={{ textTransform: "uppercase" }}
                    onClick={() =>
                      navigate("/brands") & dispatch(SortProducts("")) &&
                      setShow(false) &
                        setShowbefore(false) &
                        setShowfirst(false)
                    }
                  >
                    {t("Designers")}
                  </div>
                </div>

                {ShoesDesigners.map((brandsection) =>
                  brands
                    .filter((brand) => brand.name == brandsection.name)
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((sub) => (
                      <>
                        <div
                          className="searchmenunew pb-4"
                          onClick={() =>
                            setShow(false) &
                            setShowbefore(false) &
                            setShowfirst(false)
                          }
                        >
                          <div
                            onClick={() =>
                              navigate(
                                `/products?id=WJmwaMSWxtl1dK1sPZ1x&brand=${sub.id}&nameBrand=${sub.name}`
                              )
                            }
                            className="searchmenunew "
                          >
                            {i18n.language == "en" ? sub.name : sub.nameAr}
                          </div>
                        </div>
                      </>
                    ))
                )}
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                >
                  <div
                    className="searchmenunew"
                    style={{ fontFamily: "Montserrat-SemiB" }}
                    onClick={() =>
                      navigate("/products?id=WJmwaMSWxtl1dK1sPZ1x") &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("View All Shoes")}
                  </div>
                </div>
              </>
            )}

            {subtype == "Women" && (
              <>
                <div
                  className="w-100 pt-2 pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenutitle"
                    style={{ textTransform: "uppercase" }}
                    onClick={() =>
                      navigate(
                        "/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=WFA967se7qX0jYtySgTj"
                      ) & dispatch(SortProducts("")) &&
                      setShow(false) &
                        setShowbefore(false) &
                        setShowfirst(false)
                    }
                  >
                    {t("Women")}
                  </div>
                </div>

                {SubCategory.filter(
                  (subcat) => subcat.idTypeCategory == "WJmwaMSWxtl1dK1sPZ1x"
                )
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((sub) => (
                    <div
                      className="searchmenunew pb-4"
                      onClick={() =>
                        setShow(false) &
                        setShowbefore(false) &
                        setShowfirst(false)
                      }
                    >
                      <div
                        onClick={() =>
                          navigate(
                            `/products?id=WJmwaMSWxtl1dK1sPZ1x&subcategory=${sub.id}&gender=WFA967se7qX0jYtySgTj`
                          )
                        }
                        className="searchmenunew "
                      >
                        {i18n.language == "en" ? sub.name : sub.nameAr}
                      </div>
                    </div>
                  ))}
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    style={{ fontFamily: "Montserrat-SemiB" }}
                    onClick={() =>
                      navigate(
                        "/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=WFA967se7qX0jYtySgTj&"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("View All Women Shoes")}
                  </div>
                </div>
              </>
            )}

            {subtype == "Men" && (
              <>
                <div
                  className="w-100 pt-2 pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenutitle"
                    style={{ textTransform: "uppercase" }}
                    onClick={() =>
                      navigate(
                        "/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=KG3s4pPk3arcBux5ERnD&"
                      ) & dispatch(SortProducts("")) &&
                      setShow(false) &
                        setShowbefore(false) &
                        setShowfirst(false)
                    }
                  >
                    {t("Men")}
                  </div>
                </div>

                {SubCategory.filter(
                  (subcat) =>
                    subcat.idTypeCategory == "WJmwaMSWxtl1dK1sPZ1x" &&
                    (subcat.id == "Ajx4IbmZyd8tDPIUIWq1" ||
                      subcat.id == "29Qawt6kqsKBjKzJZURl" ||
                      subcat.id == "nngqcr84nZuxMUVQwbdZ" ||
                      subcat.id == "dhO2kQHheerGxSy5CBIE")
                )
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((sub) => (
                    <div
                      className="searchmenunew pb-4"
                      onClick={() =>
                        setShow(false) &
                        setShowbefore(false) &
                        setShowfirst(false)
                      }
                    >
                      <div
                        onClick={() =>
                          navigate(
                            `/products?id=WJmwaMSWxtl1dK1sPZ1x&subcategory=${sub.id}&gender=KG3s4pPk3arcBux5ERnD`
                          )
                        }
                        className="searchmenunew "
                      >
                        {i18n.language == "en" ? sub.name : sub.nameAr}
                      </div>
                    </div>
                  ))}
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                >
                  <div
                    className="searchmenunew"
                    style={{ fontFamily: "Montserrat-SemiB" }}
                    onClick={() =>
                      navigate(
                        "/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=KG3s4pPk3arcBux5ERnD&"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("View All Men Shoes")}
                  </div>
                </div>
              </>
            )}

            {subtype == "Kids" && (
              <>
                <div
                  className="w-100 pt-2 pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenutitle"
                    style={{ textTransform: "uppercase" }}
                    onClick={() =>
                      navigate(
                        "/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=uw8UHRzTK2qlgU8Y4cVc&"
                      ) & dispatch(SortProducts("")) &&
                      setShow(false) &
                        setShowbefore(false) &
                        setShowfirst(false)
                    }
                  >
                    {t("Kids")}
                  </div>
                </div>

                {SubCategory.filter(
                  (subcat) =>
                    subcat.idTypeCategory == "WJmwaMSWxtl1dK1sPZ1x" &&
                    (subcat.id == "Ajx4IbmZyd8tDPIUIWq1" ||
                      subcat.id == "29Qawt6kqsKBjKzJZURl" ||
                      subcat.id == "nngqcr84nZuxMUVQwbdZ" ||
                      subcat.id == "dhO2kQHheerGxSy5CBIE" ||
                      subcat.id == "MUMXw3hjGufq8nrZgCi3")
                )
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((sub) => (
                    <div
                      className="searchmenunew pb-4"
                      onClick={() =>
                        setShow(false) &
                        setShowbefore(false) &
                        setShowfirst(false)
                      }
                    >
                      <div
                        onClick={() =>
                          navigate(
                            `/products?id=WJmwaMSWxtl1dK1sPZ1x&subcategory=${sub.id}&gender=uw8UHRzTK2qlgU8Y4cVc`
                          )
                        }
                        className="searchmenunew "
                      >
                        {i18n.language == "en" ? sub.name : sub.nameAr}
                      </div>
                    </div>
                  ))}
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                >
                  <div
                    className="searchmenunew"
                    style={{ fontFamily: "Montserrat-SemiB" }}
                    onClick={() =>
                      navigate(
                        "/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=uw8UHRzTK2qlgU8Y4cVc&"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("View all kids shoes")}
                  </div>
                </div>
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default SeacrhMenuShoes;
